import script from "./GearPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GearPage.vue?vue&type=script&setup=true&lang=js"

import "./GearPage.vue?vue&type=style&index=0&id=3f497d3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f497d3f"]])

export default __exports__